import React, { PureComponent } from 'react';
import { Button, Modal } from 'antd';
import { history } from 'store';
import update from 'immutability-helper';
import { connect } from 'react-redux';
import { getPreviousStep, getCurrentStep } from 'store/booking/selector';
import { getAuthData } from 'store/auth/selector';
import { setCurrentStepAction } from 'store/booking/action';

class Header extends PureComponent {
  state = { isLogin: false, isShowModal: false };

  _onBackButtonClick = e => {
    e.preventDefault();
    history.goBack();
  };

  _renderLeftHeader = () => {
    return (
      <div>
        <div className="uk-margin uk-text-right">
          {/* <a className="uk-link-muted">
            <span className="uk-text-middle">New patient? </span>
          </a> */}
          {/* <a onClick={this.handleLogin} href="#">
            Register here
          </a>
          <span uk-icon="user" className="uk-text-primary uk-icon"></span> */}
          <a
            className="uk-link-muted"
            href="#"
            onClick={this._onBackButtonClick}
          >
            <div className="visible-desktop">
              <span uk-icon="chevron-left" className="uk-icon"></span>
              <span className="uk-text-middle">Back</span>
            </div>
            <div className="visible-mobile">
              <span uk-icon="chevron-left" className="uk-icon"></span>
              <span className="uk-text-middle">Prev</span>
            </div>
          </a>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <div className="uk-container uk-container-small">
          <div className="uk-grid-margin uk-grid" uk-grid="">
            {this._renderLeftHeader()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    previousStep: getPreviousStep(state),
    currentStep: getCurrentStep(state),
    authData: getAuthData(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrentStep: options => dispatch(setCurrentStepAction(options)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);
